import Cookies from 'js-cookie';
import { UserManager } from 'oidc-client-ts';

import { getAuthCookieOptions } from '@/auth/authCookies';
import { oidcConfig } from '@/config';
import { ACCESS_TOKEN, ACCESS_TOKEN_PHOENIX } from '@/legacy/constants/cookies';
import { setAppUrlFromToken, tlpBase } from '@/utils/gateway';

export const userManager = new UserManager(oidcConfig);

export const syncAuthCookie = (accessToken: string) => {
  const tlpUrl = tlpBase();
  const options = getAuthCookieOptions(tlpUrl);
  Cookies.set(ACCESS_TOKEN_PHOENIX, accessToken, options);
  Cookies.set(ACCESS_TOKEN, accessToken, options);
};

// Keep the JWT cookies in sync with silent token renewals so the legacy /tlp
// backend doesn't reject calls with a stale token mid-session.
//
// Order matters: update the TLP host first so `syncAuthCookie` can compute the
// shared cookie domain from the freshly-loaded `app_url` claim.
userManager.events.addUserLoaded((user) => {
  const appUrl = (user.profile as { app_url?: unknown }).app_url;
  const tlpUrl = typeof appUrl === 'string' ? appUrl : undefined;
  setAppUrlFromToken(tlpUrl);
  syncAuthCookie(user.access_token);
});

userManager.events.addUserUnloaded(() => {
  setAppUrlFromToken(undefined);
});
